module.exports = __webpack_public_path__ + "static/media/trainer2.4a351729.jpg";